import type { CreatureMeterCapsInput, CreatureMeterCapsResult } from '../types';

const integer = (value: number): number => {
    const result = Math.trunc(Number.isFinite(value) ? value : 0);
    return Object.is(result, -0) ? 0 : result;
};

/** Compile PC-only hunger/thirst caps after final size lookup. */
export function compileCreatureMeterCaps(input: CreatureMeterCapsInput): CreatureMeterCapsResult {
    if (input.itemType !== 'player_character' || input.sizeId === '' || input.sizeData === null) return {};
    const hungerMax = integer(input.sizeData.hungerMeterMax);
    const thirstMax = integer(input.sizeData.thirstMeterMax);
    return {
        ...(hungerMax !== 0 ? { hunger_max: hungerMax } : {}),
        ...(thirstMax !== 0 ? { thirst_max: thirstMax } : {}),
    };
}
